import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router , NavigationEnd} from "@angular/router";
import { StageSandbox } from "app/stage/services/stage.sandbox";
import { StageService } from 'app/stage/services/stage.service';
import { Observable } from "rxjs/Observable";
import * as animations from "../../../shared/animations";
import * as stageTypes from "../../types";
import * as _ from "lodash";
import { BlockTemplateComponent } from "../../../shared/components/block-template/block-template.component";
import { startTimeRange } from "@angular/core/src/profile/wtf_impl";
import { TYPES } from "app/stage/types/constants";
@Component({
  selector: "tr-stage-container",
  animations: [animations.fadeInUpAnimation],
  templateUrl: "./stage-container.component.html"
  //styleUrls: ['./stage-container.component.scss']
})
export class StageContainerComponent implements OnInit, OnDestroy {
  private isLoading$: Observable<boolean> = this.sb.isDataLoading$();
  private currentStageId$: Observable<number> = this.sb.getCurrentStageId$();
  private currentPage$: Observable<stageTypes.IPage> = this.sb.getCurrentPage$();

  private stageInfo$: Observable<stageTypes.IMobileStageResponse> = this.sb.getMobileStageInfo$();
  private blockTemplate = BlockTemplateComponent;

  private type : string;
  private typeID: number ;
  private taskID: number;

  constructor(private sb: StageSandbox, private route: ActivatedRoute, private service: StageService, private router: Router) {

    this.route.params.subscribe(params => {

      this.type = params["type"];
      this.service.setType(this.type);

      this.typeID = params["typeid"];
      this.service.setTypeID(this.typeID);

      if(params['taskid']) {
        this.taskID = params['taskid'];
        this.service.setTaskID(this.taskID);
      } else {
        this.taskID = 0;
        this.service.setTaskID(0);
      }

      // if(this.type != 'starter' && this.taskID > 0 ) {
      //    this.sb.resetCurrentStageId();
      // } else if (this.type != 'starter' && !this.taskID ) {
      //   this.sb.resetCurrentStageId();
      // }

      // Above was convoluted
      if(this.type != 'starter') {
        this.sb.resetCurrentStageId();
      }

    });
  }

  ngOnInit() {
    this.sb.getStageInfo_Data$();
  }

  ngOnDestroy(): void {
    //this.sb.onComponentDestroy();
  }

  getStageList() {
    return this.sb.getStageList();
  }

  isStarter() {
    return this.type == 'starter' ? true : false ;
  }

  getStageVisibility(currentStageId: number) {

    const currentStage = _.find(
      this.getStageList(),
      stage => stage.id === currentStageId
    );
    return currentStage && currentStage.visible;
  }

  getCurrentStageInfo() {
    return this.sb.getCurrentStageInfo();
  }

  getPageTemplate(currentStageId: number) {
    if(this.type == TYPES.STARTER) {
      switch (currentStageId) {
        case 0:
          return `<tr-error-stage-container [entity]="entity"></tr-error-stage-container>`;
        case 1: // currentStageId = 1 => render WelcomePage
          return `<tr-welcome-container [entity]="entity"></tr-welcome-container>`;
        case 2:
          return `<tr-personal-detail-container [entity]="entity"></tr-personal-detail-container>`;
        case 3:
          return `<tr-doc-confirmation-container [entity]="entity"></tr-doc-confirmation-container>`;
        case 4:
        case 31:
          return `<tr-mobile-number-confirmation [entity]="entity" [additional]="additional"></tr-mobile-number-confirmation>`;
        case 5:
        case 40:
          return `<tr-final-confirmation-container [entity]="entity"></tr-final-confirmation-container>`;
        case 6:
          return `<tr-sub-login-container [entity]="entity"></tr-sub-login-container>`;
        default:
          return "<div></div>";
      }
    }
    else
    {
      // inductee and offboardee
      if (this.taskID > 0 )
      {
        currentStageId = 2;// offboard: taskID >0 always stage 2, when taskID is blank, alwasy stage 1(task list page)
      }

      switch (currentStageId) {
          case 0:
            return `<tr-error-stage-container [entity]="entity"></tr-error-stage-container>`;
          case 1: // currentStageId = 1 => render WelcomePage, stage 1, task ID 0
            return `<tr-tasks-container [entity]="entity"></tr-tasks-container>`;
          case 2: // render task questions, stage 1 task ID > 0
            return `<tr-task-questions-container [entity]="entity"></tr-task-questions-container>`;
          case 3: // stage 3 task 0, all tasks completed, basically same as stage 1 task list page
            return `<tr-tasks-container [entity]="entity"></tr-tasks-container>`;
          case 5: // stage 5 task 0, offboard completed
            return `<tr-tasks-container [entity]="entity"></tr-tasks-container>`;
          default:
            return "<div></div>";
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/stage/containers/stage-container/stage-container.component.ts